import { useEffect, useState } from "react";
import { AppDispatch } from "../../store";
import { useDispatch } from "react-redux";
import REITab from "../../components/ui/tab";
import "../../styles/custom.scss";
import { ITab } from "../../interface/tab";
import MyTrackerIndex from "./MyTracker/Index";

import { fetchMemberEntities, fetchMemberProfiles } from "../../store/slice/myTrackerSlice";
import MyCashFlowIndex from "./MyCashFlow";
import { CashFlowProvider } from "./MyCashFlow/MyCashFlowContext";
import MyPropertiesIndex from "./MyProperty/Index";
import MyEquity from "./MyEquity/MyEquity";
import MyEntityGoalsIndex from "./MyEntityAndGoals";
import MyPhoneBook from "./MyPhoneBook/MyPhoneBook";
import { useLocation, useNavigate } from "react-router-dom";
import { FilterSelectionProvider } from "./FilterSelectionContext";
import { REIButton } from "../../components/ui";

const PortfolioTrackerIndex = () => {
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchMemberProfiles());
    dispatch(fetchMemberEntities());
  }, [dispatch]);

  const { tab, entityId } = location.state || {};

  const { MyPropertyId } = location.state || {};

  useEffect(() => {
    const newState = {
      ...location.state,
      tab: undefined,
    };

    navigate(location.pathname, {
      replace: true,
      state: newState,
    });
  }, []);

  useEffect(() => {
    if (MyPropertyId) {
      location.state = { ...location.state, MyPropertyId: MyPropertyId };
    } else {
      location.state = { ...location.state, MyPropertyId: undefined };
    }
  }, [MyPropertyId, location.state]);

  const [activeTab, setActiveTab] = useState(() => {
    if (tab && tab === "MyEntityGoals") {
      return 4;
    }
    if (tab && tab === "MyPropertyTab") {
      return 3;
    }
    if (tab && tab === "MyCashFlowTab") {
      return 1;
    }
    if (tab && tab === "MyEquityTab") {
      return 2;
    }
    return 0;
  });

  useEffect(() => {
    if (tab && tab === "MyPropertyTab") {
      setActiveTab((prev) => 3);
      location.state = { ...location.state, tab: undefined };
    } else if (tab && tab === "MyCashFlowTab") {
      setActiveTab(1);
      location.state = { ...location.state, tab: undefined };
    } else if (tab && tab === "MyEquityTab") {
      setActiveTab(2);
      location.state = { ...location.state, tab: undefined };
    } else if (tab && tab === "MyEntityGoals") {
      setActiveTab(4);
      location.state = { ...location.state, tab: undefined, entityId: entityId || undefined };
    } else {
      location.state = { ...location.state, MyPropertyId: undefined };
    }
  }, [tab]);

  const [tabs, setTabs] = useState<ITab[]>([
    {
      header: "My Tracker",
      content: (
        <div>
          <MyTrackerIndex></MyTrackerIndex>
        </div>
      ),
      closable: false,
    },
    {
      header: "My Cash Flow",
      content: (
        <div>
          <CashFlowProvider>
            <MyCashFlowIndex></MyCashFlowIndex>
          </CashFlowProvider>
        </div>
      ),
      closable: false,
    },
    {
      header: "My Equity",
      content: (
        <div>
          <MyEquity></MyEquity>
        </div>
      ),
      closable: false,
    },
    {
      header: "My Properties",
      content: <MyPropertiesIndex MyPropertyId={MyPropertyId}></MyPropertiesIndex>,
      closable: false,
    },
    {
      header: "My Entities & Goals",
      content: <MyEntityGoalsIndex></MyEntityGoalsIndex>,
      closable: false,
    },
    {
      header: "My Phonebook",
      content: <MyPhoneBook />,
      closable: false,
    },
  ]);

  return (
    <>
      <div className=" mx-auto p-4 content-center justified-between-tabview ">
        <FilterSelectionProvider>
          <REITab
            id="ptidx-tab-main"
            tabs={tabs}
            activeIndex={activeTab}
            onTabChange={(e) => setActiveTab(e.index)}
            classNames=""
          ></REITab>
        </FilterSelectionProvider>
      </div>
      <div className="content-center justify-center flex mb-2 align-middle gap-2">
        <span className="text-center content-center italic">What do you think of Portfolio Tracker? </span>
        <REIButton
          id={"ptidx-btn-feedback"}
          text
          label="Leave Feedback"
          onClick={() => {
            window.open("https://info.realestateinvestar.com.au/satisfaction-survey", "_blank");
          }}
          classNames="border-1 border-blue-200"
        ></REIButton>
      </div>
    </>
  );
};

export default PortfolioTrackerIndex;
